module.exports = __webpack_public_path__ + "img/loading.cb62fb6d.svg";